// src/pages/Holiday/EmployerHolidayMasterList.js
import React, { useEffect, useState, useRef } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { Row, Col } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import HolidayViewController from "../../redux/actions/HolidayApiAction";
import HolidayMasterFormModal from "./AddHolidayMaster";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ExportButton from "../../components/ag grid/ExportButton"; // ✅ NEW IMPORT
import usePermission from "../../utils/usePermission";

const EmployerHolidayMasterList = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedHolidays, setSelectedHolidays] = useState([]);
  const gridRef = useRef();
  const [pageSize, setPageSize] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]); // ✅ NEW STATE

  const { getHolidays } = MasterViewController();
  const { getEmployerHoliday } = HolidayViewController();
  const { hasPermission } = usePermission();
  const { holidays } = useSelector((state) => state.master);
  const { employer_holiday } = useSelector((state) => state.employer_holidays);

 
  useEffect(() => {
    dispatch(getHolidays());
    dispatch(getEmployerHoliday());
  }, [dispatch]);

  const handleOpenModal = () => {
    setShowModal(true);
    if (employer_holiday) {
      const alreadySelectedIds = employer_holiday.map((item) =>
        item.holiday ? item.holiday.id : item.id
      );
      setSelectedHolidays(alreadySelectedIds);
    }
  };

  const onGridReady = (params) => {
    gridRef.current = params.api;
    params.api.sizeColumnsToFit();
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      pinned: "left",
    },
    {
      headerName: "SR No.",
      valueGetter: "node.rowIndex + 1",
      width: 90,
    },
    {
      headerName: "Occasion",
      valueGetter: (params) => params.data.holiday?.occasion,
      flex: 1,
      width: 200,
    },
    {
      headerName: "Date",
      valueGetter: (params) => params.data.holiday?.date,
      flex: 1,
    },
    {
      headerName: "Day",
      valueGetter: (params) => params.data.holiday?.day,
      flex: 1,
    },
  ];

  return (
    <div style={{ width: "100%", minHeight: "100vh", backgroundColor: "#f1f3f5" }}>
      {/* ✅ Export + PageSize + Add Holiday - Right Side */}
      <div className="d-flex flex-wrap mb-3 gap-2" style={{ justifyContent: "space-between" }}>
     <div className="mt-2">
     {hasPermission("oragnization_holiday_management", "create") &&( 
      <Button
      variant="contained"
      startIcon={<AddCircleOutline />}
      onClick={handleOpenModal}
      sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",                  
            }}
    >
      Add Holiday
    </Button>
    )}
  </div>

  {/* Right side: PageSizeSelector + Add Holiday */}
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <div>
    {hasPermission("oragnization_holiday_management", "export") && (
      <ExportButton
        gridRef={gridRef}
        fileName="employer_holidays.xlsx"
        exportColumns={["holiday.occasion", "holiday.date", "holiday.day"]}
        disabled={selectedRows.length === 0}
      />
    )}
    </div>
    <PageSizeSelector
      pageSize={pageSize}
      onChange={(e) => setPageSize(Number(e.target.value))}
    />
    
  </div>
</div>


      {/* <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Holiday List</h3>
          </Col>
        </Row>
      </div> */}

      <div style={{ height: "75vh", width: "100%" }} className="ag-theme-material">
        <ReusableGrid
          columnDefs={columnDefs}
          rowData={employer_holiday}
          gridRef={gridRef}
          pagination={true}
          onGridReady={onGridReady}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)} // ✅ ADDED FOR SELECTION
        />
      </div>

      <HolidayMasterFormModal
        show={showModal}
        onHide={() => setShowModal(false)}
        selectedHolidays={selectedHolidays}
        setSelectedHolidays={setSelectedHolidays}
      />
    </div>
  );
};

export default EmployerHolidayMasterList;
